









const DeviceStoreDetail = (props)=>{

    return (
        <>
           
        </>
    );
}

export default DeviceStoreDetail;